// Anything exported from this file is importable by other in-browser modules.
export function createSurvey(data) {
  try {
    const {
      pnr,
      flightDeparture,
      moment,
      motive,
      afected,
      bundle,
      paxQuantity,
      position = "widget_bottom left",
      survey,
      url = "https://air.qservus.com",
      canal = undefined,
    } = data;
    const surveyObject = {
      REFUND_REQUEST_SUCCESS: {
        id: "kHJOxC",
        description: "Página de éxito solicitud de devolución",
      },
      INITIAL_SALE_SUCCESS: {
        id: "SNxaz6",
        description: "Página de éxito compra inicial",
      },
      CHECK_IN_SUCCESS: {
        id: "4dDhx1",
        description: "Página de éxito check-in",
      },
      MODIFY_FLIGHT_SUCCESS: {
        id: "9mw4pz",
        description: "Página de éxito modificación de vuelo",
      },
      ADD_ANCILLARY_SUCCESS: {
        id: "mqnaCJ",
        description: "Página de éxito adición de ancillaries (MMB)",
      },
    };

    const [, language = "es", homeMarket = "chile"] =
      window.location.pathname.split("/");
    let div = document.createElement("div");
    div.id = "qservus-widget-container";
    document.body.appendChild(div);
    let script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute(
      "src",
      "https://cdn-qservus.redcalidad.com/cache/js/embed.min.js?v=2.1.41"
    );
    script.id = "survey-script";
    script.setAttribute("data-language", language);
    script.setAttribute("data-url", url);
    script.setAttribute(
      "data-survey",
      survey ? survey : surveyObject[moment].id
    );
    script.setAttribute("data-position", position);
    script.setAttribute("data-hm", homeMarket);
    const attributes = {
      "data-fecha_vuelo": flightDeparture,
      "data-motivo": motive,
      "data-afectado": afected,
      "data-bundle": bundle,
      "data-cant-pasajeros": paxQuantity,
      "data-pnr": pnr,
      "data-momento": moment,
      "data-canal": canal,
    };

    Object.entries(attributes).forEach(([key, value]) => {
      if (value) {
        script.setAttribute(key, value);
      }
    });

    document.body.appendChild(script);
  } catch (error) {}
}
